import * as React from "react";
import {
  Box,
  Button,
  TextField,
  MenuItem,
  useTheme,
  Grid,
} from "@mui/material";
import { tokens } from "../../theme";

export default function FilterZbalance({
  isSalesMan,
  users = [],
  filters,
  setFilters,
  onFilter,
  onReset,
}) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box
      p={2}
      mb={3}
      borderRadius={2}
      sx={{ backgroundColor: colors.primary[400] }}
    >
      <Grid container spacing={2} alignItems="center">
        {/* ✅ USER FILTER (ADMIN ONLY) */}
        {!isSalesMan && (
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              select
              label="User"
              variant="filled"
              value={filters.userId}
              onChange={(e) =>
                setFilters((s) => ({ ...s, userId: e.target.value }))
              }
              fullWidth
            >
              <MenuItem value="">All Users</MenuItem>
              {users.map((u) => (
                <MenuItem key={u.id} value={u.id}>
                  {u.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        )}

        {/* ✅ FROM DATE */}
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="From Date"
            type="date"
            variant="filled"
            InputLabelProps={{ shrink: true }}
            value={filters.fromDate}
            onChange={(e) =>
              setFilters((s) => ({ ...s, fromDate: e.target.value }))
            }
            fullWidth
          />
        </Grid>

        {/* ✅ TO DATE */}
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="To Date"
            type="date"
            variant="filled"
            InputLabelProps={{ shrink: true }}
            value={filters.toDate}
            onChange={(e) =>
              setFilters((s) => ({ ...s, toDate: e.target.value }))
            }
            fullWidth
          />
        </Grid>


        {/* ✅ RESET BUTTON */}
        <Grid item xs={6} sm={3} md={1.5}>
          <Button
            variant="outlined"
            onClick={onReset}
            fullWidth
            sx={{ height: "56px" }}
          >
            Reset
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
